const portfolioCsv = {
  WAYPOINT: 'Commentaire météo',
  'CUSTOM-PROJECTMETA': {
    IMGURL: 'Photo',
    CODE: 'Code projet',
    NAME: 'Nom du projet',
  },
  'CUSTOM-CATEGORY-LIST1': 'Type produit',
  'CUSTOM-CATEGORY-LIST2': 'Phase/Jalon',
  'CUSTOM-CATEGORY-LIST3': 'Statut',
  'CUSTOM-ANNEELANCEMENT': 'Année lancement',
  'CUSTOM-FAMILLE': 'Type projet (charge)',
  'CUSTOM-RECURRENCE': 'Récurrence',
  'CUSTOM-MOULE': 'Moule',
  'CUSTOM-CODEPRODUIT': 'Code produit',
  'CUSTOM-NUMPLAN': 'N° plan',
  'CUSTOM-BESOINDEVPACKAGING': 'Besoin dev packaging',
  'CUSTOM-QTESETUP': 'Qté set-up',
  'CUSTOM-QTEANNUELLE': 'Qté 12 mois',
  'CUSTOM-GOINDUS': {
    DATE: 'Date GO INDUS',
    TARGET: 'Cible GO INDUS',
  },
  'CUSTOM-BAT': {
    DATE: 'Date BAT',
    TARGET: 'Cible BAT',
  },
  'CUSTOM-DISPOMOULE': {
    DATE: 'Date Dispo MOULE',
    TARGET: 'Cible Dispo MOULE',
  },
  'CUSTOM-MAD': {
    DATE: 'Date MAD',
    TARGET: 'Cible MAD',
  },
  'CUSTOM-INITIALISATION': 'Date INITIALISATION PROJET',
  'CUSTOM-EXPEDITION': 'EXPEDITION ET DESACTIVATION CODE',
  'CUSTOM-REMISE-DEVIS': 'REMISE DEVIS',
  'CUSTOM-CONFIRMATION-DEVIS': 'CONFIRMATION DEVIS',
  'CUSTOM-DELAI-DEVIS': 'Délai annoncé devis',
  'CUSTOM-CLIENT': 'Client ext. (AfS/BtoB)',
  'CUSTOM-DEMANDEUR': 'Demandeur',
  'CUSTOM-SECTION': 'Section',
  BUDGET: {
    TARGET: 'Budget cible €',
    AMOUNT: 'Budget total €',
    AMOUNT_INPROGRESS: 'Budget en cours €',
  },
  'CUSTOM-PRSESTIME': 'PRS estimé',
  'CUSTOM-MARGESURPV': 'Marge sur PV',
};

export default {
  fr: {
    PROJECT_SHEET: {
      TARGET_ENDTIME: "Date MAD cible",
    },
    PORTFOLIO: {
      CSV: portfolioCsv,
    },
  },
  en: {
    PROJECT_SHEET: {
      TARGET_ENDTIME: "Target MAD date",
    },
    PORTFOLIO: {
      CSV: portfolioCsv,
    },
  },
};
